import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { DigitsGroupingPipe } from '../pipes';
import { SkeletonTemplateService } from '@skeleton-loader';
import { ConfigurationService } from '@core';

@Component({
  selector: 'lib-product-details-price',
  imports: [CommonModule, DigitsGroupingPipe],
  templateUrl: './product-details-price.component.html',
  styleUrl: './product-details-price.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductDetailsPriceComponent {
  protected readonly rewardName = inject(ConfigurationService).rewardName;
  newPrice = input.required<number>();
  oldPrice = input.required<number | null>();
  loading = input.required<boolean>();

  skeletonService = inject(SkeletonTemplateService);
}
